// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const SmallHeading = styled.div`
  text-align: center;
  max-width: 600px;
  font-size: 18px;
  line-height: 25px;
  margin-bottom: 20px;
  font-weight: 600;
`;

export const PublicJobsContainer = styled.div`
  margin-top: 32px;
  margin-bottom: 32px;
`;

export const JobsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 600px;
  margin: 0 auto;
`;
